import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m15.996 16.5 1.519.379A2 2 0 0 0 20 14.939V7.061a2 2 0 0 0-2.485-1.94l-12 3A2 2 0 0 0 4 10.061v1.876a2 2 0 0 0 1.515 1.94l1.574.394A3 3 0 0 0 7 15v.491a3 3 0 0 0 2.176 2.885l3 .857a3 3 0 0 0 3.82-2.734M9.03 14.756 14 16v.349a1 1 0 0 1-1.275.961l-3-.857A1 1 0 0 1 9 15.49V15q0-.126.03-.243",
      clipRule: "evenodd"
    }
  )
);
var SvgFeedbackFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FeedbackFilled_default = SvgFeedbackFilled;

export { FeedbackFilled_default as default };
